/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { useEffect, useState } from 'react'

export const useDocumentVisibility = () => {
  const [documentIsVisible, setDocumentIsVisible] = useState<boolean>(true)

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        console.log('Document is visible. Welcome back! 😊')
      } else {
        console.log('Document is hidden. Please back as soon as possible 😔')
      }
      setDocumentIsVisible(document.visibilityState === 'visible')
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return documentIsVisible
}
